/* THE COURT & CLUB — product page behaviour. Loaded only on the PDP. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var CFG = window.CCLUXE || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Same money contract as the shared bundle: reuse the shop's own format. */
  function group(str, t, d) {
    var p = String(str).split('.');
    var i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
    return d && p[1] ? i + d + p[1] : i;
  }
  function money(c) {
    var n = (c || 0) / 100, f = CFG.moneyFormat;
    if (f) {
      return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, k) {
        switch (k) {
          case 'amount_no_decimals': return group(Math.round(n), ',', '');
          case 'amount_with_comma_separator': return group(n.toFixed(2), '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(Math.round(n), '.', '');
          case 'amount_with_space_separator': return group(n.toFixed(2), ' ', ',');
          default: return group(n.toFixed(2), ',', '.');
        }
      });
    }
    try {
      return new Intl.NumberFormat(CFG.locale || 'en-US',
        { style: 'currency', currency: CFG.currency || 'USD' }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }
  function cartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- 1. free-shipping progress, at the moment of decision ---------- */
  (function freeShip() {
    var el = $('[data-pdpfs]', root);
    var TH = parseInt(CFG.freeShip, 10) || 0;
    if (!el || !TH) return;
    var count = null;

    /* The free rate is Standard, never Priority — "free express shipping"
       promised a $19.95 service we do not give away. */
    function paint(total) {
      var left = Math.max(TH - total, 0);
      var pct = Math.min((total / TH) * 100, 100);
      el.className = 'pfs' + (left <= 0 ? ' done' : '');
      el.innerHTML =
        '<p class="pfs__t">' + (left <= 0
          ? '<b>Free shipping unlocked.</b>'
          : 'Add <b>' + money(left) + '</b> more for free shipping') + '</p>' +
        '<span class="pfs__bar"><i style="width:' + pct.toFixed(1) + '%"></i></span>';
      el.hidden = false;
    }

    function refresh() {
      return cartJson().then(function (c) { count = c.item_count; paint(c.total_price); })
        .catch(function () { });
    }

    /* This used to be a single refresh 800ms after the click. On a phone that
       fires before /cart/add.js has answered, so the bar kept reading
       "Add $75.00 more" beside a bag that already held a $135 racket. Watch
       the cart until it actually changes rather than guessing how long the
       network will take, and give up after a few seconds either way. */
    function watch() {
      var before = count;
      var tries = 0;
      (function tick() {
        cartJson().then(function (c) {
          paint(c.total_price);
          var changed = c.item_count !== before;
          count = c.item_count;
          if (!changed && ++tries < 8) setTimeout(tick, 400);
        }).catch(function () { });
      })();
    }

    refresh();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-add], [data-add-main], [data-addall]')) watch();
    });
    document.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('form[action*="/cart/add"]')) watch();
    });
  })();

  /* ---------- 2. add the whole add-on set in one call ---------- */
  (function addAll() {
    var btn = $('[data-addall]', root);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ids = (btn.getAttribute('data-addall') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          var opener = document.querySelector('[data-cart-open]');
          if (opener) opener.click();
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.textContent = label; btn.disabled = false; });
    });
  })();

  /* ---------- 3. size recommender, read straight off the fit table ---------- */
  (function sizer() {
    var box = $('[data-sizer]');
    if (!box) return;
    var table = $('#fit table');
    if (!table) { box.hidden = true; return; }

    /* Column 1 is the size label, column 2 the chest range — the table is the
       single source of truth, so editing it in the theme editor updates this. */
    var rows = $$('tbody tr', table).map(function (tr) {
      var td = $$('td', tr);
      var range = (td[1] || {}).textContent || '';
      var nums = range.replace(/[^\d.–—-]/g, '').split(/[–—-]/).filter(Boolean).map(parseFloat);
      return { size: ((td[0] || {}).textContent || '').trim(), lo: nums[0], hi: nums[1] != null ? nums[1] : nums[0] };
    }).filter(function (r) { return r.size && !isNaN(r.lo); });
    if (!rows.length) { box.hidden = true; return; }

    var input = $('[data-sizer-chest]', box);
    var fit = $('[data-sizer-fit]', box);
    var out = $('[data-sizer-out]', box);

    $('[data-sizer-go]', box).addEventListener('click', function () {
      var v = parseFloat(input.value);
      if (!(v > 0)) { out.textContent = 'Enter your chest measurement in inches.'; out.hidden = false; return; }
      var idx = -1;
      for (var i = 0; i < rows.length; i++) { if (v >= rows[i].lo && v <= rows[i].hi) { idx = i; break; } }
      if (idx === -1) idx = v < rows[0].lo ? 0 : rows.length - 1;
      var shift = fit.value === 'relaxed' ? 1 : (fit.value === 'close' ? -1 : 0);
      var pick = rows[Math.min(Math.max(idx + shift, 0), rows.length - 1)];
      out.innerHTML = 'We would put you in a <b>' + pick.size + '</b>.' +
        (shift ? ' Adjusted for a ' + fit.value + ' fit.' : '');
      out.hidden = false;
    });
  })();

  /* ---------- 4. the gallery is a carousel, not a column ----------
     Eleven photos used to be eleven near-full-height rows, so seeing the
     product meant scrolling past the buy button. The markup is unchanged —
     cc-fix2.css lays .gal__main out as an x-snapping flex row and this wires
     the controls to it. Slide width equals the scroller width, which is what
     makes scrollLeft / clientWidth a reliable slide index. */
  var carouselIndex = null;
  var galMain = null;

  /* Promote the frames around the current one from lazy to eager, so the
     photo is decoded before a swipe or an arrow arrives at it. Without this
     a fast swipe outran the loader and showed an empty box for a beat —
     which reads as lag even though the scroll itself is instant. */
  function warm(i) {
    if (!galMain) return;
    var figs = $$('.gal__i', galMain);
    [i - 1, i, i + 1, i + 2].forEach(function (n) {
      var fig = figs[n];
      if (!fig) return;
      var img = fig.querySelector('img');
      if (!img || img.dataset.ccWarm) return;
      img.dataset.ccWarm = '1';
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.decode) img.decode().catch(function () { });
    });
  }

  /* `auto`, never `smooth`: an animated jump cost about a third of a second
     on every arrow, dot, thumbnail and colour swatch. */
  function goToSlide(i) {
    if (!galMain) return;
    var n = $$('.gal__i', galMain).length;
    i = Math.max(0, Math.min(i, n - 1));
    warm(i);
    galMain.scrollTo({ left: galMain.clientWidth * i, behavior: 'auto' });
  }

  (function carousel() {
    var gal = $('.gal');
    if (!gal) return;
    var main = $('.gal__main', gal);
    if (!main) return;
    galMain = main;
    var slides = $$('.gal__i', main);
    if (slides.length < 2) return;   /* one photo needs no controls */

    /* A scroller cannot host its own absolutely-positioned arrows — they would
       scroll away with the slides — so give it a positioned wrapper. */
    var wrap = document.createElement('div');
    wrap.className = 'galx';
    main.parentNode.insertBefore(wrap, main);
    wrap.appendChild(main);

    function arrow(kind, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'galn galn--' + kind;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"/></svg>';
      wrap.appendChild(b);
      return b;
    }
    var prev = arrow('p', 'Previous image', 'M15 4l-8 8 8 8');
    var next = arrow('n', 'Next image', 'M9 4l8 8-8 8');

    var dots = document.createElement('div');
    dots.className = 'galdots';
    slides.forEach(function (_s, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Image ' + (i + 1));
      d.addEventListener('click', function () { goToSlide(i); });
      dots.appendChild(d);
    });
    wrap.appendChild(dots);

    /* The rail was <a href="#gal-3">, which jumped the PAGE to the slide.
       Scroll the carousel instead and leave the page where it is. */
    var thumbs = $$('.gth', gal);
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); goToSlide(i); });
      /* a pointer heading for a thumbnail is a reliable tell */
      t.addEventListener('mouseenter', function () { warm(i); });
    });

    function index() {
      if (!main.clientWidth) return 0;
      return Math.max(0, Math.min(Math.round(main.scrollLeft / main.clientWidth), slides.length - 1));
    }
    function sync() {
      var i = index();
      carouselIndex = i;
      warm(i);
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      $$('button', dots).forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      prev.disabled = i <= 0;
      next.disabled = i >= slides.length - 1;
      if (thumbs[i] && thumbs[i].scrollIntoView) {
        try { thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { }
      }
    }
    prev.addEventListener('click', function () { goToSlide(index() - 1); });
    next.addEventListener('click', function () { goToSlide(index() + 1); });

    /* Short debounce: the counter, dots and rail should catch up with a swipe
       almost as it lands, not a tenth of a second later. */
    var t;
    main.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(sync, 40);
    }, { passive: true });

    /* Warm ahead the moment a swipe begins, before we know where it lands. */
    main.addEventListener('touchstart', function () { warm(index()); }, { passive: true });

    /* A resize changes the slide width, so the old scrollLeft now points
       between two slides. Re-anchor on the one that was showing. */
    window.addEventListener('resize', function () {
      var i = carouselIndex == null ? 0 : carouselIndex;
      main.scrollLeft = main.clientWidth * i;
      sync();
    }, { passive: true });

    gal.setAttribute('tabindex', '-1');
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(index() - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(index() + 1); }
    });

    sync();
  })();

  /* ---------- 5. the gallery follows the colour ----------
     Every colourway has its own photo, but choosing "Red" left a white skirt
     on screen — on a thirteen-colour product that is the difference between
     seeing what you are buying and guessing. The variant JSON the section
     prints carries no image, so map the variants to slides by filename from
     /products/<handle>.js, which Shopify serves from cache. */
  (function variantMedia() {
    if (!galMain) return;
    var slides = $$('.gal__i', galMain);
    if (slides.length < 2) return;

    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;

    function file(u) {
      if (!u) return '';
      return (u.split('?')[0].split('/').pop() || '').replace(/_\d+x\d*(_crop_\w+)?(?=\.)/, '');
    }

    var slideOf = {};
    slides.forEach(function (fig, i) {
      var img = fig.querySelector('img');
      if (!img) return;
      var f = file(img.getAttribute('src') || img.src);
      if (f && slideOf[f] === undefined) slideOf[f] = i;
    });

    var byVariant = {};
    var last = null;

    function apply() {
      var el = $('[data-vid]', root);
      var vid = el && el.value;
      if (!vid || vid === last) return;
      last = vid;
      var i = byVariant[vid];
      if (i !== undefined) goToSlide(i);
    }

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        (p.variants || []).forEach(function (v) {
          var src = v.featured_image && v.featured_image.src;
          if (!src) return;
          var i = slideOf[file(src)];
          if (i !== undefined) byVariant[v.id] = i;
        });
        /* The shared bundle also listens for this event and writes [data-vid];
           defer a tick so we read the value it just set, not the old one. */
        root.addEventListener('change', function (e) {
          if (e.target.matches('[data-opt] input')) setTimeout(apply, 0);
        });
        /* Warm the frame under the pointer before the click lands. */
        root.addEventListener('mouseover', function (e) {
          var lab = e.target.closest('.pills--sw .pil');
          if (!lab) return;
          var inp = lab.querySelector('input');
          var i = inp && byVariant[inp.value];
          if (i !== undefined) warm(i);
        });
        last = null;
        apply();   /* land on the right slide when the URL carried ?variant= */
      })
      .catch(function () { });
  })();

  /* The hover magnifier that used to live here is gone — it scaled the photo
     to 1.85x and tracked the cursor as the transform origin, which cropped
     the product rather than revealing it. Clicking still opens the lightbox,
     which is the right place for a close look. See cc-fix4.css. */
})();
